import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EmployeeModel } from '../../models/EmployeeModel';
import * as actions from './quickbooks.actions';

// this is just to handle the keys
export const quickbooksFeatureKey = 'QuickbooksOnline';
export interface SendHoursProgressInfo {
    current: number;
    total: number;
}
export interface QuickbooksOnlineState {
    HasValidTokens: boolean;
    AuthUrl: string;
    EmployeesWithHours: EmployeeModel[] | null;
    ContractorsWithHours: EmployeeModel[] | null;
    EmployeesWithPurchases: EmployeeModel[] | null;
    MinApprovedTimeNotSent: Date | null;
    MaxApprovedTimeNotSent: Date | null;
    SendHoursInProgress: boolean;
    SendHoursProgress: SendHoursProgressInfo | null;
}
export const initialState: QuickbooksOnlineState = {
    HasValidTokens: false,
    AuthUrl: '',
    EmployeesWithHours: null,
    ContractorsWithHours: null,
    EmployeesWithPurchases: null,
    MinApprovedTimeNotSent: null,
    MaxApprovedTimeNotSent: null,
    SendHoursInProgress: false,
    SendHoursProgress: null
};

export function reducer(
    state = initialState,
    action: actions.ActionsUnion
): QuickbooksOnlineState {
    switch (action.type) {
        case actions.ActionTypes.HasValidTokens:
            return {
                ...state,
                HasValidTokens: action.payload
            };
        case actions.ActionTypes.SetAuthUrl:
            return {
                ...state,
                AuthUrl: action.payload
            };
        case actions.ActionTypes.SetEmployeesWithHours:
            return {
                ...state,
                EmployeesWithHours: action.payload
            };
        case actions.ActionTypes.SetContractorsWithHours:
            return {
                ...state,
                ContractorsWithHours: action.payload
            };
        case actions.ActionTypes.SetEmployeesWithPurchases:
            return {
                ...state,
                EmployeesWithPurchases: action.payload
            };
        case actions.ActionTypes.SetMinApprovedTimeNotSent:
            return {
                ...state,
                MinApprovedTimeNotSent: action.payload
            };
        case actions.ActionTypes.SetMaxApprovedTimeNotSent:
            return {
                ...state,
                MaxApprovedTimeNotSent: action.payload
            };
        case actions.ActionTypes.SendHours:
            return {
                ...state,
                SendHoursInProgress: true,
                SendHoursProgress: {
                    current: 0,
                    total: action.payload.EmployeeListIDs?.length ?? 0
                }
            };
        case actions.ActionTypes.SendHoursProgress:
            return {
                ...state,
                SendHoursProgress: action.payload
            };
        case actions.ActionTypes.SendHoursSuccess:
        case actions.ActionTypes.SendHoursFailure:
            return {
                ...state,
                SendHoursInProgress: false,
                SendHoursProgress: null
            };

        default:
            return state;
    }
}
